import React, { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import PageHeader from '../components/PageHeader';
import { registerAdmin } from '../services/api';
import { useAuth } from '../context/AuthContext';

export default function AdminRegister() {
  const [form, setForm] = useState({ fullName: '', email: '', password: '', setupKey: '' });
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const { login } = useAuth();

  const handleChange = (e) => setForm({ ...form, [e.target.name]: e.target.value });

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');

    if (form.password.length < 6) {
      setError('Password must be at least 6 characters.');
      return;
    }

    setLoading(true);
    try {
      // The backend stores this as "username" — we derive it from the name entered
      const username = form.fullName.trim().toLowerCase().replace(/[^a-z0-9]/g, '');
      const res = await registerAdmin({ ...form, username });
      login(res.data);
      navigate('/admin');
    } catch (err) {
      setError(err.response?.data?.message || 'Could not create admin account.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div>
      <PageHeader
        eyebrow="Staff Setup"
        title="Create an Admin Account"
        subtitle="This page requires the admin setup key configured on the server. It is not for public/member registration."
      />
      <section className="section">
        <div className="container" style={{ maxWidth: 460 }}>
          <div className="card">
            {error && <p className="error-text" style={{ marginBottom: 16 }}>{error}</p>}
            <form onSubmit={handleSubmit}>
              <div className="form-group">
                <label>Full Name</label>
                <input name="fullName" required value={form.fullName} onChange={handleChange} />
              </div>
              <div className="form-group">
                <label>Email</label>
                <input type="email" name="email" required value={form.email} onChange={handleChange} />
              </div>
              <div className="form-group">
                <label>Password</label>
                <input type="password" name="password" required value={form.password} onChange={handleChange} />
              </div>
              <div className="form-group">
                <label>Admin Setup Key</label>
                <input type="password" name="setupKey" required value={form.setupKey} onChange={handleChange} />
                <p style={{ fontSize: '0.8rem', color: 'var(--color-grey)', marginTop: 6 }}>
                  This matches <code>app.admin.registration.key</code>.
                </p>
              </div>
              <button type="submit" className="btn btn-gold btn-block" disabled={loading}>
                {loading ? 'Creating account...' : 'Create Admin Account'}
              </button>
              <p style={{ textAlign: 'center', marginTop: 16, fontSize: '0.9rem' }}>
                Not staff? <Link to="/register" style={{ color: 'var(--color-gold)', fontWeight: 600 }}>Member registration is here</Link>
              </p>
            </form>
          </div>
        </div>
      </section>
    </div>
  );
}

